import * as Action from "../Action/Action";
import * as Data from "../Data/Data";

type ActionProps = {
	type: "ACTION";
} & Action.ActionProps;

type DataProps = { type: "DATA" } & Data.DataProps;

export type AddonProps = ActionProps | DataProps;

export const Addon = (props: AddonProps) => {
	if (props.type === "ACTION") {
		const { type, ...actionProps } = props;
		return <Action.Action {...actionProps} />;
	}

	if (props.type === "DATA") {
		const { type, ...dataProps } = props;
		return <Data.Data {...dataProps} />;
	}

	return null;
};
